import { render, staticRenderFns } from "./PlanningGroupsDialog.vue?vue&type=template&id=bc83b510&scoped=true&lang=pug&"
import script from "./PlanningGroupsDialog.vue?vue&type=script&lang=ts&"
export * from "./PlanningGroupsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningGroupsDialog.vue?vue&type=style&index=0&id=bc83b510&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc83b510",
  null
  
)

export default component.exports